import React, { useEffect, useState } from 'react';
import { getSections, getMenuItems } from '../api/menu-api.js';

const MenuItem = ({ image_url, name, description, name_arabic, description_arabic, price, lastItem, lang }) => {
  
  return (
    <div className={`flex justify-start items-center gap-3 sm:gap-6 py-4 px-2 sm:px-0 ${!lastItem ? 'border-b border-gold-dark/30' : ''} transition-colors duration-300 bg-slate-50 dark:bg-gray-950`}>
      <img
        src={image_url}
        alt={lang === 'en'? name : name_arabic}
        className="max-[350px]:size-24 max-[400px]:size-28 size-32 object-cover rounded-lg shadow-md border-2 border-gold-dark/20 dark:border-gold-dark/30 max-w-[300px] sm:max-w-none self-center sm:self-start"
      />
      <div className='flex flex-col flex-1 gap-2 w-full'>
        <div className='flex flex-col gap-1 items-start'>
          <h3 className={`font-serif text-xl text-gold-dark font-semibold`}>
            {lang === 'en'? name : name_arabic}
          </h3>
          <p className={`text-gray-700 dark:text-gray-300 font-light italic`}>
            {lang === 'en'? description : description_arabic}
          </p>
        </div>
        <div className='w-full flex items-center gap-3'>
          <div className='flex-1 h-[1px] border-t border-dashed border-gold-dark/50'></div>
          <span className="text-gold-dark font-bold text-2xl">
            {price} {lang === "en"? 'LBP' : 'ل.ل.'}
          </span>
        </div>
      </div>
    </div>
  );
};

const MenuSection = ({ title, title_arabic, items }) => {
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'en');
  
  // Listen for language changes using an effect
  useEffect(() => {

    setLang(localStorage.getItem('lang') || 'en');
    
    const handleStorageChange = () => {
      setLang(localStorage.getItem('lang') || 'en');
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('languageChange', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('languageChange', handleStorageChange);
    };
  }, []);

  return (
    <section className="flex flex-col w-full max-w-full sm:max-w-[600px] bg-slate-50 dark:bg-gray-950 shadow-xl rounded-2xl border border-gold-dark/10 dark:border-gold-dark/20">
      <div className='sticky top-[64px] w-full flex items-center justify-center'>
        <div className='flex-1 border-t border-gold-dark'></div>
        <h2 className="w-fit text-2xl sm:text-4xl px-6 sm:px-8 py-3 sm:py-4 font-serif bg-gradient-to-r from-gold-dark/30 to-gold-dark/20 dark:from-gold-dark/40 dark:to-gold-dark/30 text-gold-dark dark:text-gold-light font-bold text-center relative">
          <span className="relative z-10">{lang === "en" ? title : title_arabic}</span>
          <span className="absolute inset-0 border-b-2 border-gold-dark/40 dark:border-gold-light/40"></span>
          <span className="absolute -left-1 -right-1 h-[2px] bottom-0 bg-gradient-to-r from-transparent via-gold-dark/60 dark:via-gold-light/60 to-transparent"></span>
        </h2>
        <div className='flex-1 border-t border-gold-dark'></div>
      </div>
      <div className="flex flex-col divide-y divide-gold-dark/20 dark:divide-gold-dark/30 px-2 sm:px-6 py-2 sm:py-4">
        {items.map((item, index) => (
          <MenuItem 
            key={index} 
            {...item} 
            lastItem={index === items.length - 1}
            lang={lang}
          />
        ))}
        
      </div>
    </section>
  );
}

function Menu() {
  const [menuData, setMenuData] = useState([])
  const fetchData = async () => {
    try {
      const [sections, items] = await Promise.all([
        getSections(),
        getMenuItems()
      ]);


      const grouped = {};
      sections.forEach(section => {
        grouped[section.id] = {
          id: section.id,
          name: section.name,
          name_arabic: section.name_arabic,
          items: items.filter(item => item.section_id === section.id),
        };
      });
      const filteredMenuData = Object.values(grouped).filter(section => section.items.length > 0);
      setMenuData(filteredMenuData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData()
  }, [])
  
  return (
    <div className="container mx-auto px-2 sm:px-4 py-8 sm:py-12 flex justify-center flex-wrap gap-6 sm:gap-10 dark:bg-gray-900 min-h-screen">
      {menuData.map((section, index) => {
        return (
          <MenuSection 
            key={index} 
            title={section.name} 
            title_arabic={section.name_arabic}
            items={section.items} 
          />
        );
      })}
    </div>
  );
}

export default Menu;